import type { FC } from "react";
import type {
	ClientPortfolioDetailToolResponseDTO,
	ClientPortfolioToolReportingSummaryResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { ToolType } from "web_myplann/Portfolio/Helpers/investmentToolTypes";
import {
	getToolType,
	makeRowKey,
} from "web_myplann/Portfolio/Helpers/investmentToolUtils";
import { BankProductToolRow } from "./BankProductToolRow";
import { BondToolRow } from "./BondToolRow";
import { CommodityToolRow } from "./CommodityToolRow";
import { CryptoToolRow } from "./CryptoToolRow";
import { DefaultToolRow } from "./DefaultToolRow";
import { InvestmentToolRow } from "./InvestmentToolRow";

type Props = {
	tools: ClientPortfolioDetailToolResponseDTO[];
	portfolioId: number;
	currencySign: string;
	toolsSummary?: ClientPortfolioToolReportingSummaryResponseDTO[];
	expandedMap: Record<string, boolean>;
	setExpanded: (key: string, value: boolean) => void;
	noDivider: boolean;
};

export const ToolRowList: FC<Props> = ({
	tools,
	portfolioId,
	currencySign,
	toolsSummary,
	expandedMap,
	setExpanded,
	noDivider,
}) => {
	return (
		<>
			{tools.map((tool, toolIdx) => {
				const rowKey = makeRowKey(tool);
				const toolType = getToolType(tool);
				const isLastItem = toolIdx === tools.length - 1;

				const commonProps = {
					tool,
					toolIdx,
					portfolioId,
					currencySign,
					toolsSummary,
					expanded: !!expandedMap[rowKey],
					onToggle: (v: boolean) => setExpanded(rowKey, v),
					noDivider: isLastItem && noDivider,
				};

				switch (toolType) {
					case ToolType.Commodity:
						return <CommodityToolRow key={tool.id} {...commonProps} />;
					case ToolType.Crypto:
						return <CryptoToolRow key={rowKey} {...commonProps} />;
					case ToolType.Investment:
						return <InvestmentToolRow key={tool.id} {...commonProps} />;
					case ToolType.Bond:
						return <BondToolRow key={tool.id} {...commonProps} />;
					case ToolType.BankProduct:
						return <BankProductToolRow key={tool.id} {...commonProps} />;
					default:
						return <DefaultToolRow key={tool.id} {...commonProps} />;
				}
			})}
		</>
	);
};
